import React from 'react'
import { TerminPageTemplate } from '../../templates/termin-page'

const TerminPagePreview = ({ entry }) => {
  const data = entry.getIn(['data']).toJS()

  return <TerminPageTemplate title={data.title} />
}

export default TerminPagePreview
